module.exports = __webpack_public_path__ + "staticcomp/img/top.8f5fcf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/16/top.jpg
// module id = 5hQK
// module chunks = 39